import { ValueFormatterParams } from "ag-grid-enterprise";
import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";
import { useMemo } from "react";

type Props = CustomCellEditorProps & {};

function WarrantyCellEditor(props: Props) {
  const { stopEditing, onValueChange, value } = props;

  const warrantyList = useMemo(
    () =>
      [...Array(21).keys()].map((v: number) => {
        if (v === 20) return { label: "Lifetime warranty", value: 100 };
        return {
          label: `${v + 1} ${v === 0 ? "year" : "years"}`,
          value: v + 1
        };
      }),
    []
  );

  return (
    <Select
      value={value || undefined}
      placeholder="Select warranty"
      options={warrantyList}
      virtual={false}
      style={{ width: "100%" }}
      data-testid="warrantycelleditor-select"
      allowClear
      onChange={(event: any) => {
        onValueChange(event);
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
    />
  );
}

export default WarrantyCellEditor;

export const WarrantyValueFormatter = (params: ValueFormatterParams) =>
  params?.data?.warranty
    ? `${params?.data?.warranty}  ${
        params?.data?.warranty === 1 ? "year" : "years"
      }`
    : "";
